import styles from "./index.module.scss";
import React from "react";

export function InputSelectComponent({ data, required = true }) {
  const isObjectArray =
    data.options.length > 0 && typeof data.options[0] === "object";

  return (
    <div>
      <label htmlFor={data.name} className={styles.formLabel}>
        {data.label}
      </label>
      <select
        className={styles.formSelect}
        name={data.name}
        id={data.name}
        required={required}
      >
        {data.options.map((option, index) => {
          if (isObjectArray) {
            const displayText = option.key || option.label || option.value;
            const value = option.value || option.key || option.label;
            return (
              <option value={value} key={index}>
                {displayText}
              </option>
            );
          } else {
            return (
              <option value={option} key={index}>
                {option}
              </option>
            );
          }
        })}
      </select>
    </div>
  );
}
